import api from '../api/client';

/**
 * [LIVE-DIAG] — TEMPORARY diagnostics for the Phase 76 production
 * verification (live stability on iOS/Android). Logs to the browser
 * console AND (fire-and-forget) to the backend, so events from real
 * phones show up in the deployed backend logs.
 *
 * NO tokens, signed URLs, credentials or personal data — only event
 * names, live ids and boolean/short flags.
 *
 * REMOVE AFTER VERIFICATION: delete this file, the POST /api/live-diag
 * endpoint and every `liveDiag(` call (grep "LIVE-DIAG" / "liveDiag").
 */
const liveDiag = (event, data = {}) => {
  try { console.info(`[LIVE-DIAG] ${event}`, data); } catch (_e) { /* noop */ }
  try { api.post('/live-diag', { event, ...data }).catch(() => {}); } catch (_e) { /* noop */ }
};

export default liveDiag;
